import { InjectionToken } from '@angular/core';
import { BathroomService } from '../services/configurators-2d/applications/bathroom.service';

export const BA_SERVICE = new InjectionToken(typeof BathroomService);

export const bathroomProviders = [
  {
    provide: BA_SERVICE,
    useClass: BathroomService,
  },
];
